import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getProductGroupMasters = createAsyncThunk(
  "productGroupMaster/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.PRODUCT_GROUP_MASTER.SLUG}?${queryString}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Lookup variant — hits the permission-free /lookup endpoint. Used by dropdowns
// on screens of other modules; the management list keeps using getProductGroupMasters.
export const getProductGroupMastersLookup = createAsyncThunk(
  "productGroupMaster/getLookup",
  async (payload, { rejectWithValue }) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.PRODUCT_GROUP_MASTER.LOOKUP}?${queryString}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createProductGroupMaster = createAsyncThunk(
  "productGroupMaster/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.PRODUCT_GROUP_MASTER.SLUG}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const editProductGroupMaster = createAsyncThunk(
  "productGroupMaster/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.PRODUCT_GROUP_MASTER.SLUG}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const deleteProductGroupMaster = createAsyncThunk(
  "productGroupMaster/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${API_URL.PRODUCT_GROUP_MASTER.SLUG}/${id}`,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

const productGroupMasterSlice = createSlice({
  name: "productGroupMaster",
  initialState: {
    product_group_master_list: [],
    current_values: null,
    active_payload: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProductGroupMasters.fulfilled, (state, action) => {
      state.product_group_master_list = action.payload.data.list;
    });
    builder.addCase(getProductGroupMastersLookup.fulfilled, (state, action) => {
      state.product_group_master_list = action.payload.data.list;
    });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  productGroupMasterSlice.actions;
export default productGroupMasterSlice.reducer;
